@if (visible) {
<div
  class="z-50 fixed inset-0 flex justify-center items-center bg-black bg-opacity-60 px-8 min-w-[300px] min-h-[400px]">
  <div
    [ngClass]="asahi ? 'flex flex-col justify-center  items-center bg-[#201E1F] shadow-[0_100px_80px_0_rgba(0,0,0,0.24),0_55.458px_46.356px_0_rgba(0,0,0,0.16),0_38.832px_37.189px_0_rgba(0,0,0,0.13),0_28.259px_30.707px_0_rgba(0,0,0,0.10),0_19.622px_23.137px_0_rgba(0,0,0,0.08),0_10.804px_13.112px_0_rgba(0,0,0,0.05)]  p-[60px_48px] rounded-2xl w-[400px] sm:w-[400px]':'flex flex-col justify-center  items-center bg-white shadow-xl p-[60px_48px] rounded-2xl w-[400px] sm:w-[600px]'">
    <div class="flex flex-col items-start gap-4 self-stretch">
    <p *ngIf="!asahi"
      [ngClass]="asahi 
        ? 'text-white text-center font-[manrope] text-[16px] not-italic font-medium leading-[17px] tracking-[1px] uppercase' 
        : 'text-[#00B884] text-center font-[manrope] text-[16px] not-italic font-medium leading-[17px] tracking-[1px] uppercase'">
      {{'Contact us' | translate}}
    </p>
    <h1 *ngIf="!asahi"
      [ngClass]="asahi 
          ? 'self-stretch text-white font-[manrope] text-[24px] sm:text-[45px] not-italic font-extrabold leading-[120%] tracking-[-0.9px]'
          : 'self-stretch text-[#F5375C] font-[manrope] text-[24px] sm:text-[45px] not-italic font-extrabold leading-[120%] tracking-[-0.9px]'">
      {{'Verify your number' | translate}}
    </h1>
      <div [ngClass]="asahi ?'mb-4 text-white text-[14px] sm:text-lg':'mb-4 text-black text-[14px] sm:text-lg'">
        {{ 'We have sent a 4 digit OTP code via SMS to your number' | translate }}
        <span class="font-bold">{{ getMaskedPhoneNumber() }}</span>
        <span class="ml-2 text-[#2AD189] underline cursor-pointer" (click)="onEdit()">
          {{ 'Edit' | translate }}
        </span>
      </div>

      <hr class="w-[90%] h-[1.669px] bg-[#D9DBE9] border-0" />
      <div class="flex items-center gap-3 justify-between self-center px-[120px] mb-4">
        @for (i of otpDigits; track i) {
          <input
                maxlength="1"
                type="tel"
                inputmode="numeric"
                pattern="[0-9]*"
                class="bg-white border border-[#B6B6B6] rounded-lg focus:outline-none focus:ring-[#2AD189] focus:ring-2 w-12 h-12 text-black text-2xl text-center"
                [(ngModel)]="otp[i]"
                (input)="onOtpInput(i, $event)"
                (keydown)="onOtpKeydown(i, $event)"
                (keypress)="onKeyPress($event)"
                autocomplete="one-time-code"
                />
                
        }
      </div>
    </div>

    <!-- Error Message Display -->
    @if (errorMsg || errorMsg ==='Incorrect OTP') {
    <div class="mb-4 text-[#F03457] text-sm text-center">
      {{ errorMsg | translate }}
    </div>
    }

    @if (errorMsg === 'OTP expired. Please request a new one.') {
    <div class="bg-[#2d2c2c] mb-4 p-2 w-full text-white text-sm text-center">
      {{ 'OTP expired. Please request a new one.' | translate }}
    </div>
    }
    <button class="flex justify-center items-center px-12 py-3 rounded-full bg-[#2AD189]"
     [ngClass]="isOtpValid() ? 'bg-[#2AD189] text-black font-bold' : ' bg-[#2AD189] opacity-50 cursor-not-allowed text-black font-bold'" 
     [disabled]="!isOtpValid()"
      (click)="onVerifyOtp()">
      {{ asahi ? 'Verify': 'Submit' | translate }}
    </button>

    <div class="my-2 text-sm text-center">
      @if (resendCountdown > 0) {
      <span class="mb-2 text-gray-400">{{ 'Resend the code later' | translate }} {{ resendCountdown | number:'2.0'
        }}</span>
      } @else {
      <span class="mb-2 text-[#2AD189] cursor-pointer" (click)="onResendCode()">{{ 'Tap to resend code' | translate
        }}</span>
      }
    </div>
    <div class="flex justify-center items-center gap-4 self-stretch py-[10px]">
      <hr class="w-full border-t border-gray-300 hidden sm:block" />
      <hr class="w-full border-t border-gray-300 hidden sm:block" />
      <hr class="w-full border-t border-gray-300 block sm:hidden" />

    </div>
    <div class="flex flex-col sm:flex-row  gap-3 mt-2 ">
    <button
      class="flex justify-center items-center gap-2 self-stretch px-4 py-2 rounded-[99px] font-medium max-md:text-sm text-nowrap transition-all duration-200 disabled:cursor-not-allowed"
      [ngClass]="[
        asahi ? ' bg-[#444444] text-[#F5375C]' : 'border border-[#2F262A]/50',
        isOtpValid() ? 'text-[#FF557D] hover:text-[#F5375C]' : 'text-black opacity-60'
      ]" [disabled]="resendCountdown > 0" (click)="onZaloVerify()" [attr.aria-disabled]="!isOtpValid()"
      [attr.title]="!isOtpValid() ? 'Enter OTP to enable' : ''">
      <img src="png/zalo.png" class="w-5 h-5" alt="Zalo" />
      <span>{{ 'Verify via Zalo' | translate }}</span>
    </button>
    
    <button
      class="flex justify-center items-center gap-2 self-stretch px-4 py-2 rounded-[99px] font-medium max-md:text-sm text-nowrap transition-all duration-200 disabled:cursor-not-allowed"
      [ngClass]="[
        asahi ? 'bg-[#444444] text-[#F5375C]' : 'border border-[#2F262A]/50',
        isOtpValid() ? 'text-[#FF557D] hover:text-[#F5375C]' : 'text-black opacity-60'
      ]" [disabled]="!isOtpValid()" (click)="isOtpValid() ? onCallVerify() : null" [attr.aria-disabled]="!isOtpValid()"
      [attr.title]="!isOtpValid() ? 'Enter OTP to enable' : ''">
      <img src="png/PhoneCall.svg" class="w-5 h-5" alt="Phone Call" />
      <span>{{ 'Verify via Call' | translate }}</span>
    </button>
    </div>
  </div>
</div>
}